import { HttpClient, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponseModel, HttpService } from "../services/http-service";
import { environment } from "../../environments/environment";
import { Lead } from "../models/lead";
import { Observable, tap } from "rxjs";
import { ErrorService } from "../services/error-service.service";
import { ErrorConstants } from "../../constants/error_constants";

@Injectable({
    providedIn: 'root',
})
export class LeadApi {

    constructor(
        private http: HttpClient,
        private httpService: HttpService,
        private errorService: ErrorService
    ) {

    }

    createLead(lead: Lead, newLead: boolean = false): Observable<ApiResponseModel> {
        const url = `${environment.url}lead/nb/create/`;

        const request = {
            lead: lead,
            newLead
        };

        this.errorService.setError(ErrorConstants.CREATE_LEAD);

        return this.http.post<ApiResponseModel>(url, request).pipe(
            this.httpService.formatApiResponse()
        );
    }

    updateLead(lead: Lead, identifier: any): Observable<Response> {
        let url = environment.url + "lead/nb/" + identifier + "/update/";

        this.errorService.setError(ErrorConstants.UPDATE_LEAD);

        return this.http.post<Response>(url, { lead: lead })
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    getUniqueLinkEducationalInstitution(unique_id: any): Observable<Response> {

        let url = environment.url + "api_admin/educational_institutions/unique_link_ei/";

        this.errorService.setError(ErrorConstants.GET_UNIQUE_LINK_EI);

        const request = {
            ei_unique_id: unique_id,
        }

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    getEducationalInstitutionsFromGroup(unique_id: any): Observable<Response> {
        let url = environment.url + "api_admin/educational_institutions/education_group/institutions/";

        this.errorService.setError(ErrorConstants.GET_EI_FROM_GROUP);

        const request = {
            unique_id: unique_id,
        }

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }
    // This uses elastic search, only use if really needed
    searchEducationalInstitutions(name: string, filter_partner_school: boolean): Observable<Response> {
        let url = environment.url + "api_admin/educational_institutions/search/";

        this.errorService.setError(ErrorConstants.SEARCH_EI);

        const request = {
            name: name,
            filter_partner_school: filter_partner_school,
            env: 'nedbank'
        };

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    sendNedbankLinkEmail(lead: Lead, link: string): Observable<Response> {
        let url = environment.url + "api_admin/notifications/nedbank_send_link/";

        this.errorService.setError(ErrorConstants.SEND_LINK_EMAIL);

        const request = {
            lead: lead,
            link: link
        };

        return this.http.post<any>(url, request).pipe(tap({
            next: (event: any) => {
                return this.httpService.formattedResponse(event);
            },
            error: (error: any) => {
                return this.httpService.formattedResponse(error);
            }
        }));
    }
    updateLeadStatus(lead_data: any): Observable<Response> {
        let url = environment.url + "lead/nb/update_status/";
    
        this.errorService.setError(ErrorConstants.UPDATE_LEAD_STATUS);  
        
    
        return this.http.post<Response>(url, lead_data)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }
}

